import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useToast } from "contexts/toast/toast.context";
import { useAuth, USER_ROLE } from "contexts/auth/auth.context";
import { DEFAULT_CALENDAR_CONFIG, useCalendarConfig } from "contexts/calendar/calendar.context";
import { mobileTransferAuth } from "api/client/mobile-transfer-auth";

export const useMobileTransferLogin = () => {
  const navigate = useNavigate();
  const { loginContext } = useAuth();
  const { updateCalendarSettings } = useCalendarConfig();
  const { addFailureToast } = useToast();

  const { mutate } = useMutation({
    mutationFn: (code: string) => mobileTransferAuth(code),
    onSuccess: (data) => {
      loginContext(data);

      const calendar = data.calendar;
      updateCalendarSettings({
        config: calendar ? {
          start: calendar.start ? calendar.start.slice(0, 5) : DEFAULT_CALENDAR_CONFIG.start,
          end: calendar.end ? calendar.end.slice(0, 5) : DEFAULT_CALENDAR_CONFIG.end,
          step: calendar.step != null ? Number(calendar.step) : DEFAULT_CALENDAR_CONFIG.step,
          showWeekends: calendar.showWeekends ?? DEFAULT_CALENDAR_CONFIG.showWeekends,
          isAllowedTimeLock: calendar.allowTimeLock ?? DEFAULT_CALENDAR_CONFIG.isAllowedTimeLock,
          backgroundColorScheme: calendar.backgroundColorScheme ?? "Białe",
        } : DEFAULT_CALENDAR_CONFIG
      });

      navigate(data.role === USER_ROLE.ROLE_PATIENT ? "/clientAppointments" : "/");
    },
    onError: (err) => {
      const message = isAxiosError(err)
        ? err.response?.data?.message || err.message
        : (err as Error).message;
      addFailureToast(message || "Wystąpił niespodziewany błąd.");
      navigate("/login");
    },
  });

  const onMobileTransferAuth = ({ code }: { code: string }) => {
    mutate(code);
  };

  return { onMobileTransferAuth };
};
